export default __webpack_public_path__ + "static/media/artifact-pro.cf807d8b.png";